import React from "react";
import $ from "jquery";

import "./gallery.css";

export default function GalleryComponent() {
  $(function () {
    var selectedClass = "";
    $(".filter").click(function () {
      selectedClass = $(this).attr("data-rel");
      $("#gallery").fadeTo(100, 0.1);
      $("#gallery div")
        .not("." + selectedClass)
        .fadeOut()
        .removeClass("animation");
      setTimeout(function () {
        $("." + selectedClass)
          .fadeIn()
          .addClass("animation");
        $("#gallery").fadeTo(300, 1);
      }, 300);
    });
  });

  return (
    <div style={{ margin: "20px" }}>
      {/* <!-- Grid row --> */}
      <div class="row">
        {/* <!-- Grid column --> */}
        <div class="col-md-12 d-flex justify-content-center mb-5">
          <button
            type="button"
            class="btn btn-outline-info waves-effect filter GallaryBtn"
            data-rel="all"
          >
            All
          </button>
          <button
            type="button"
            class="btn btn-outline-info waves-effect filter GallaryBtn"
            data-rel="1"
          >
            Certificates
          </button>
          <button
            type="button"
            class="btn btn-outline-info waves-effect filter GallaryBtn"
            data-rel="2"
          >
            Projects
          </button>
          <button
            type="button"
            class="btn btn-outline-info waves-effect filter GallaryBtn"
            data-rel="3"
          >
            Events
          </button>
        </div>
        {/* <!-- Grid column --> */}
      </div>
      {/* <!-- Grid row --> */}
      {/* <!-- Grid row --> */}
      <div class="gallery" id="gallery">
        {/* <!-- Grid column --> */}
        <div class="mb-3 pics animation all 3">
          <img
            class="img-fluid"
            src="https://firebasestorage.googleapis.com/v0/b/senurajayadeva-394f1.appspot.com/o/senurajayadevamathssociety.jpg?alt=media&token=6d3c597c-3d89-4c87-97a0-abb68b8126ce"
            alt="Senura Jayadeva - Event"
          />
        </div>
        {/* <!-- Grid column --> */}

        {/* <!-- Grid column --> */}
        <div class="mb-3 pics animation all 3">
          <img
            class="img-fluid"
            src="https://firebasestorage.googleapis.com/v0/b/senurajayadeva-394f1.appspot.com/o/senurajayadeva.jpg?alt=media&token=d7a5aeb9-596b-4879-8f29-edfd602775ff"
            alt="Senura Jayadeva"
          />
        </div>
        {/* <!-- Grid column --> */}

        {/* <!-- Grid column --> */}
        <div class="mb-3 pics animation all 3">
          <img
            class="img-fluid"
            src="https://firebasestorage.googleapis.com/v0/b/senurajayadeva-394f1.appspot.com/o/senurajayadevaleo.jpg?alt=media&token=a67ac4c7-b09d-4501-87e9-4bda608e783f"
            alt="Card image cap"
          />
        </div>
        {/* <!-- Grid column --> */}

        {/* <!-- Grid column --> */}
        <div class="mb-3 pics animation all 3">
          <img
            class="img-fluid"
            src="https://firebasestorage.googleapis.com/v0/b/senurajayadeva-394f1.appspot.com/o/1604218125119.jpg?alt=media&token=bfc06445-54ff-4fba-a129-97d9a8dcae32"
            alt="Card image cap"
          />
        </div>
        {/* <!-- Grid column --> */}

        {/* <!-- Grid column --> */}
        <div class="mb-3 pics animation all 3">
          <img
            class="img-fluid"
            src="https://firebasestorage.googleapis.com/v0/b/senurajayadeva-394f1.appspot.com/o/1604218121022.jpg?alt=media&token=44b38896-8ad9-4df8-b99f-dd8dca29718a"
            alt="Card image cap"
          />
        </div>
        {/* <!-- Grid column --> */}

        {/* <!-- Grid column --> */}
        <div class="mb-3 pics animation all 1">
          <img
            class="img-fluid"
            src="https://firebasestorage.googleapis.com/v0/b/senurajayadeva-394f1.appspot.com/o/1591467989838.jpg?alt=media&token=d7b60a7b-1614-4432-bd2c-93498d19d74f"
            alt="Senura Jayadeva"
          />
        </div>
        {/* <!-- Grid column --> */}

        {/* <!-- Grid column --> */}
        <div class="mb-3 pics animation all 2">
          <img
            class="img-fluid"
            src="https://firebasestorage.googleapis.com/v0/b/senurajayadeva-394f1.appspot.com/o/1593577953353.jpg?alt=media&token=f92141a5-4a14-43e2-b350-1e0bb9362c7a"
            alt="Senura Jayadeva"
          />
        </div>
        {/* <!-- Grid column --> */}

        {/* <!-- Grid column --> */}
        <div class="mb-3 pics animation all 1">
          <img
            class="img-fluid"
            src="https://firebasestorage.googleapis.com/v0/b/senurajayadeva-394f1.appspot.com/o/1591497917069.jpg?alt=media&token=ab2b5d25-32b8-417c-b38a-d075fb0f5143"
            alt="Senura Jayadeva"
          />
        </div>
        {/* <!-- Grid column --> */}

        {/* <!-- Grid column --> */}
        <div class="mb-3 pics animation all 2">
          <img
            class="img-fluid"
            src="https://firebasestorage.googleapis.com/v0/b/senurajayadeva-394f1.appspot.com/o/1595347850565.jpg?alt=media&token=4914f86a-ea4e-45fa-a4cb-09b318c1ff29"
            alt="Senura Jayadeva"
          />
        </div>

        {/* <!-- Grid column --> */}
        <div class="mb-3 pics animation all 1">
          <img
            class="img-fluid"
            src="https://firebasestorage.googleapis.com/v0/b/senurajayadeva-394f1.appspot.com/o/1592704561619.jpg?alt=media&token=fed552f8-cd33-4724-9afb-5f490ddbb750"
            alt="Senura Jayadeva"
          />
        </div>

        {/* <!-- Grid column --> */}
        <div class="mb-3 pics animation all 1">
          <img
            class="img-fluid"
            src="https://firebasestorage.googleapis.com/v0/b/senurajayadeva-394f1.appspot.com/o/1596258793068.jpg?alt=media&token=61b7b85f-93c1-43c6-8d3b-488bac282b43"
            alt="Senura Jayadeva"
          />
        </div>

        {/* <!-- Grid column --> */}
        <div class="mb-3 pics animation all 3">
          <img
            class="img-fluid"
            src="https://firebasestorage.googleapis.com/v0/b/senurajayadeva-394f1.appspot.com/o/1605626663965.jpg?alt=media&token=5a8ba69c-0600-455b-b3de-e5e9d8b06a58"
            alt="Senura Jayadeva"
          />
        </div>

        {/* <!-- Grid column --> */}
        <div class="mb-3 pics animation all 2">
          <img
            class="img-fluid"
            src="https://firebasestorage.googleapis.com/v0/b/senurajayadeva-394f1.appspot.com/o/5.JPG?alt=media&token=89010076-dba0-49d2-8d58-8f23306a0cae"
            alt="Senura Jayadeva"
          />
        </div>

        {/* <!-- Grid column --> */}
        <div class="mb-3 pics animation all 2">
          <img
            class="img-fluid"
            src="https://firebasestorage.googleapis.com/v0/b/senurajayadeva-394f1.appspot.com/o/6.JPG?alt=media&token=77a43b20-79af-4c89-bc3a-0eec45f0417b"
            alt="Senura Jayadeva"
          />
        </div>
        {/* <!-- Grid column --> */}
        <div class="mb-3 pics animation all 2">
          <img
            class="img-fluid"
            src="https://firebasestorage.googleapis.com/v0/b/senurajayadeva-394f1.appspot.com/o/Capture.JPG?alt=media&token=2e974cf3-a9c0-4bbf-89ab-557d795fb7d3"
            alt="Senura Jayadeva"
          />
        </div>
        {/* <!-- Grid column --> */}
        <div class="mb-3 pics animation all 2">
          <img
            class="img-fluid"
            src="https://firebasestorage.googleapis.com/v0/b/senurajayadeva-394f1.appspot.com/o/Capture2.JPG?alt=media&token=9fa0f7cf-d3fd-4780-bf56-20386da63856"
            alt="Senura Jayadeva"
          />
        </div>
        {/* <!-- Grid column --> */}
        <div class="mb-3 pics animation all 2">
          <img
            class="img-fluid"
            src="https://firebasestorage.googleapis.com/v0/b/senurajayadeva-394f1.appspot.com/o/Capture4.JPG?alt=media&token=b771d869-5eb3-45d0-9f41-2214c4a17c65"
            alt="Senura Jayadeva"
          />
        </div>
        {/* <!-- Grid column --> */}
        <div class="mb-3 pics animation all 2">
          <img
            class="img-fluid"
            src="https://firebasestorage.googleapis.com/v0/b/senurajayadeva-394f1.appspot.com/o/Capture3.JPG?alt=media&token=31e305f5-5850-46cf-a6fd-abbe2d941eb9"
            alt="Senura Jayadeva"
          />
        </div>
      </div>

      {/* <!-- Grid row --> */}
    </div>
  );
}
